import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { push, goBack } from 'connected-react-router'

import { form } from 'helpers/decorators'
import {
  setWizardCompleted,
  changeWizardActive,
  changeWizardNext
} from 'redux/modules/wizard'
import { scrollToElement } from 'utils/scroll'
import withWizardContext from './WithWizardContext'
import configFile from 'config'

function decorator(config) {
  return ComposedComponent => {
    if (!config) {
      console.warn('Config is missing')
      return
    }
    if (!config.form) {
      console.warn('Form name has to be specified')
      return
    }
    @form({
      ...config,
      form: config.form,
      destroyOnUnmount: config.destroyOnUnmount,
      validate: config.validate,
      multipage: config.multipage
    })
    @connect(
      state => ({
        modalObj: state.app.modal,
        fields: state.form[config.form] && state.form[config.form].fields,
        wizardSteps: state.wizard.toJS().steps
      }),
      { push, goBack, setWizardCompleted, changeWizardActive, changeWizardNext }
    )
    @withWizardContext()
    class Wizard extends Component {
      static propTypes = {
        links: PropTypes.any,
        submitFailed: PropTypes.bool.isRequired,
        location: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
        push: PropTypes.func.isRequired,
        onFormInit: PropTypes.func.isRequired,
        setWizardCompleted: PropTypes.func.isRequired,
        goBack: PropTypes.func.isRequired
      }

      componentDidMount() {
        this.handleStepValidity(this.props.links)
        this.props.onFormInit(config.form)
      }

      componentWillReceiveProps(nextProps) {
        const { submitFailed } = this.props

        // Check if user has right to be on this route
        // if (links !== nextProps.links) {
        //   this.handleStepValidity(nextProps.links)
        // }

        // Scroll to error on first form submission fail
        if (submitFailed !== nextProps.submitFailed && nextProps.submitFailed) {
          scrollToElement()
        }
      }

      handleStepValidity = links => {
        const { route } = this.props
        const currentItem = links.findEntry(item => item.id === route.activeId)

        if (!currentItem[1].active) {
          this.props.goBack()
        }
      }

      handleSubmit = () => {
        const { route, links, location } = this.props

        const currentItem = links.findEntry(item => item.id === route.activeId)

        const search = get(location, 'search')

        this.props.setWizardCompleted(route.activeId, true)
        this.props.push(currentItem && `${configFile.publicPath}${currentItem[1].next}${search || ''}`)
      }

      render() {
        const { route, links } = this.props
        const currentItem = links.findEntry(item => item.id === route.activeId)

        return (
          <ComposedComponent
            {...this.props}
            nextPath={currentItem && currentItem[1].next}
            onSubmit={this.handleSubmit}
          />
        )
      }
    }
    return Wizard
  }
}

export default decorator
